export class ListInventoryNetworksResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networks",
            "baseName": "networks",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryNetworksResponse.attributeTypeMap;
    }
    constructor() {
    }
}
